import fetch from '../../utils/fetch'

export function getOpenId(params) {
    console.log(params,'params');
    return fetch({
        url: '/api/verify/openid?code=' + params,
        method: 'GET',
    })
}

export function getCode(params) {
    
    return fetch({
        url: '/api/verify/https/url?flag=' + params,
        // url: '/api/verify/url?flag=' + params,
        method: 'GET',
    })
}

export function HttpGetCode(params) {

    return fetch({
        // url: '/api/verify/https/url?flag=' + params,
        url: '/api/verify/url?flag=' + params,
        method: 'GET',
    })
}


// 获取buyId
export function getBuyId(code) {
    return fetch({
        url: '/api/verify/xcx/buyid?code=' + code,
        method: 'GET',
    })
}
// export function getBuyId(code) {
//     return fetch({
//         url: '/api/verify/buyid?code=' + code,
//         method: 'GET',
//     })
// }
